import { Component, Input, OnInit } from '@angular/core';
import { TodoItemFlatNode } from '../models/todo-item-flat-node';

@Component({
  selector: 'app-tree-settings',
  templateUrl: './tree-settings.component.html',
  styleUrls: ['./tree-settings.component.scss']
})
export class TreeSettingsComponent implements OnInit {

  @Input() userGlobalSettings: any;
  @Input() userSettings: any;
  @Input() globalNode: any;
  @Input() treeControl: any;
  @Input() dataSource: any;
  @Input() checklistSelection: any;
  @Input() checklistSoundSelection: any;
  @Input() checklistVibrationSelection: any;

  constructor() { }

  ngOnInit(): void {
    this.checkAllGlobalSettings();
    this.uncheckGlobalSettings();

    this.checkAllTreeNodes();
    this.uncheckTreeNodes();
  }

  private checkAllGlobalSettings() {
    this.checklistSelection.select(this.globalNode);
    this.checklistSoundSelection.select(this.globalNode);
    this.checklistVibrationSelection.select(this.globalNode);
  }

  private uncheckGlobalSettings() {
    if (this.userGlobalSettings == null) {
      return;
    }
    if (this.userGlobalSettings.selection == false) {
      this.checklistSelection.deselect(this.globalNode);
    }
    if (this.userGlobalSettings.sound == false) {
      this.checklistSoundSelection.deselect(this.globalNode);
    }
    if (this.userGlobalSettings.vibration == false) {
      this.checklistVibrationSelection.deselect(this.globalNode);
    }
  }

  private checkAllTreeNodes() {
    this.treeControl.dataNodes.forEach((node: TodoItemFlatNode) => {
      this.checklistSelection.select(node);
      this.checklistSoundSelection.select(node);
      this.checklistVibrationSelection.select(node);
    }); 
  }

  private uncheckTreeNodes() {
    if (this.userSettings == null) {
      return;
    }
    this.treeControl.dataNodes.forEach((node: TodoItemFlatNode) => {
      const nodeSetting =  this.userSettings.find((setting: any) => setting.id === node.id);
      if (nodeSetting == null) {
        return;
      }
      const parent = this.getParentNode(node);

      if (nodeSetting.selection == false) {
        this.checklistSelection.deselect(node);
        if (parent) {
          this.checklistSelection.deselect(parent);
        }
      }
      if (nodeSetting.sound == false) {
        this.checklistSoundSelection.deselect(node);
        if (parent) {
          this.checklistSoundSelection.deselect(parent);
        }
      }
      if (nodeSetting.vibration == false) {
        this.checklistVibrationSelection.deselect(node);
        if (parent) {
          this.checklistVibrationSelection.deselect(parent);
        }
      }
    });
  }

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;
  /** Whether all the descendants of the node are selected */
  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.every(child => this.checklistSelection.isSelected(child));
  }

  descendantsAllSoundSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.every(child => this.checklistSoundSelection.isSelected(child));
  }

  descendantsOneSoundSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.some(child => this.checklistSoundSelection.isSelected(child));
  }

  descendantsAllVibrationSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.every(child => this.checklistVibrationSelection.isSelected(child));
  }

  descendantsOneVibrationSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.some(child => this.checklistVibrationSelection.isSelected(child));
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  descendantsPartiallySoundSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSoundSelection.isSelected(child));
    return result && !this.descendantsAllSoundSelected(node);
  }

  descendantsPartiallyVibrationSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistVibrationSelection.isSelected(child));
    return result && !this.descendantsAllVibrationSelected(node);
  }

  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    const descendants = this.treeControl.getDescendants(node);
    const currentSelection = this.checklistSelection.isSelected(node);
    if (currentSelection) {
      this.checklistSelection.deselect(node);
      descendants.forEach(child => this.checklistSelection.deselect(child));
    } else {
      this.checklistSelection.select(node);
      descendants.forEach(child => this.checklistSelection.select(child));
    }
  }
  todoItemSoundSelectionToggle(node: TodoItemFlatNode): void {
    const descendants = this.treeControl.getDescendants(node);
    const currentSelection = this.checklistSoundSelection.isSelected(node);
    if (currentSelection) {
      this.checklistSoundSelection.deselect(node);
      descendants.forEach(child => this.checklistSoundSelection.deselect(child));
    } else {
      this.checklistSoundSelection.select(node);
      descendants.forEach(child => this.checklistSoundSelection.select(child));
    }
  }
  todoItemVibrationSelectionToggle(node: TodoItemFlatNode): void {
    const descendants = this.treeControl.getDescendants(node);
    const currentSelection = this.checklistVibrationSelection.isSelected(node);
    if (currentSelection) {
      this.checklistVibrationSelection.deselect(node);
      descendants.forEach(child => this.checklistVibrationSelection.deselect(child));
    } else {
      this.checklistVibrationSelection.select(node);
      descendants.forEach(child => this.checklistVibrationSelection.select(child));
    }
  }


  private getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    // scan backwards until you find a node at level −1
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const current = this.treeControl.dataNodes[i];
      if (current.level === currentLevel - 1) {
        return current;
      }
    }
    return null;
  }

  resetAll() {
    this.checkAllGlobalSettings();
    this.checkAllTreeNodes();
  }
}
